__turbopack_context__.v({
  "className": "inter_b2584ff2-module__vsNIva__className",
});
